import React, { useEffect } from 'react';
import { is } from 'ramda';
import PropTypes from 'prop-types';
import { Box, Typography } from '@material-ui/core';
import QuizQuestionPresenter from 'presenters/QuizQuestionPresenter';
import QuizPresenter from 'presenters/QuizPresenter';
import InputWithSlider from 'sharedComponents/InputWithSlider';

import useStyles from './useStyles';

const AnnualIncomeQuestion = props => {
  const { question, onChange, values, setValidity, manuallyChangedFields } = props;
  const classes = useStyles();

  const hasSecondField = QuizPresenter.hasSecondPerson(values);
  const incomeValue = QuizPresenter.incomeValue(values);
  const secondIncomeValue = QuizPresenter.secondIncomeValue(values);
  const total = incomeValue + secondIncomeValue;
  const readableTotal = QuizPresenter.formattedMoney(total);

  useEffect(() => {
    const isFirstFieldValueValid = is(Number, incomeValue);
    const isSecondFieldValueValid = hasSecondField ? is(Number, secondIncomeValue) : true;
    const isValid = isFirstFieldValueValid && isSecondFieldValueValid;

    setValidity(isValid);
  }, [incomeValue, secondIncomeValue]);

  const options = QuizQuestionPresenter.options(question);
  const { min, max, marksDivider, strictLimit } = options;

  const handleChangeIncomeValue = value => {
    const fieldValues = QuizPresenter.prepareFieldValues('incomeValue', value, manuallyChangedFields);
    fieldValues.forEach(onChange);
  };

  const handleChangeSecondIncomeValue = value => {
    const fieldValues = QuizPresenter.prepareFieldValues('secondIncomeValue', value, manuallyChangedFields);
    fieldValues.forEach(onChange);
  };

  return (
    <Box>
      <div className={classes.header}>
        <Typography variant="h1">{QuizQuestionPresenter.label(question)}</Typography>
        {hasSecondField && (
          <Typography variant="h1" className={classes.total}>
            {readableTotal}
          </Typography>
        )}
      </div>
      <Box mt={2} />
      <Box>
        {hasSecondField && (
          <Typography variant="body1">
            {`${QuizQuestionPresenter.description(question)} ${QuizQuestionPresenter.inputLabel(question)}`}
          </Typography>
        )}
        <InputWithSlider
          className={classes.input}
          value={incomeValue}
          min={min}
          max={max}
          marksDivider={marksDivider}
          onChange={handleChangeIncomeValue}
          strictLimit={strictLimit}
        />
      </Box>
      {hasSecondField && (
        <Box>
          <Typography variant="body1">
            {`${QuizQuestionPresenter.additionalFieldDescription(question)} ${QuizQuestionPresenter.inputLabel(
              question,
            )}`}
          </Typography>
          <InputWithSlider
            className={classes.input}
            value={secondIncomeValue}
            min={min}
            max={max}
            marksDivider={marksDivider}
            onChange={handleChangeSecondIncomeValue}
            strictLimit={strictLimit}
          />
        </Box>
      )}
    </Box>
  );
};

AnnualIncomeQuestion.propTypes = {
  question: QuizQuestionPresenter.shape().isRequired,
  onChange: PropTypes.func.isRequired,
  setValidity: PropTypes.func.isRequired,
  values: QuizPresenter.shape().isRequired,
  manuallyChangedFields: PropTypes.shape().isRequired,
};

export default AnnualIncomeQuestion;



// WEBPACK FOOTER //
// ./src/sharedComponents/Quiz/components/AnnualIncomeQuestion/AnnualIncomeQuestion.js